import React from 'react';
import { IOrder } from '@/interfaces/order';
import TemplateFooter from './components/template-footer';
import TemplateHeader from './components/template-header';
import TemplateOrderInfo from './components/template-order-info';
import TemplateOrderInfoSecond from './components/template-order-info-second';
import TemplateOrderInfoItem from './components/template-order-info-item';
import { useSetting } from '@/contexts/CompanyContext';

interface IProps {
  data: IOrder;
}

const TM01 = ({ data }: IProps) => {
  const { setting } = useSetting();
  return (
    <div
      style={{
        maxWidth: '209mm',
        minWidth: '209mm',
        minHeight: '296mm',
        maxHeight: '296mm',
        backgroundColor: 'white',
        margin: '0px auto',
        position: 'relative',
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 10,
        paddingBottom: 10,
        pageBreakBefore: 'always',
      }}
    >
      <TemplateHeader
        description="ต้นฉบับ"
        titleEn="Delivery Order"
        titleTh="ใบส่งสินค้า"
        businessUnitLogo={data.businessUnitLogo}
      />
      <TemplateOrderInfo data={data} code={data.ivNo} />
      <TemplateOrderInfoSecond data={data} />
      <TemplateOrderInfoItem
        data={data}
        isShowShiptoRemark
        items={data.orderItems}
        isProductQrcode={true}
      />
      <TemplateFooter
        paidInfoTemplate="TM01"
        footerTextLeft="ต้นฉบับ - ORIGINAL"
        footerTextRight="ต้นฉบับ - นำกลับบริษัท"
        referenceNo1={data?.customer?.reference1 || ''}
        referenceNo2={data?.customer?.reference2 || ''}
        amount={data?.summary}
        customerCode={data?.customer?.code || ''}
        ivNo={data?.ivNo}
        docNo={data?.code}
        driverToken={`${setting?.driverLink}/${data?.driverToken}` || '-'}
      />
    </div>
  );
};

export default TM01;
